// Порт ref SubBlockSettingsEditor:746-826 — «Подпись: N/max» + кнопки ±.
// В рефе блок скопирован дважды (строки и столбцы) байт-в-байт, у нас — один компонент.
import { Minus, Plus } from 'lucide-react'
import { Button } from '@teach/ui'

interface Props {
  label: string
  value: number
  min: number
  max: number
  addLabel: string
  removeLabel: string
  onAdd: () => void
  onRemove: () => void
}

export const CounterRow = ({
  label,
  value,
  min,
  max,
  addLabel,
  removeLabel,
  onAdd,
  onRemove,
}: Props) => (
  <div className="flex items-center justify-between">
    <span className="text-xs text-muted-foreground">
      {label}: {value}/{max}
    </span>
    <div className="flex gap-1">
      <Button
        variant="outline"
        size="icon-sm"
        aria-label={removeLabel}
        onClick={onRemove}
        disabled={value <= min}
        className="h-7 w-7"
      >
        <Minus className="h-3 w-3" />
      </Button>
      <Button
        variant="outline"
        size="icon-sm"
        aria-label={addLabel}
        onClick={onAdd}
        disabled={value >= max}
        className="h-7 w-7"
      >
        <Plus className="h-3 w-3" />
      </Button>
    </div>
  </div>
)
